var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ad56343a25f44c8d277ae2e6815bdb8d93e3315f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gatsby@homepl"]={id:"ad56343a25f44c8d277ae2e6815bdb8d93e3315f"};
      